import { Moment } from 'moment';

import { ItemActionBase } from 'app/buffer-graph/models/item-actions/item-action-base';

export class ItemAction extends ItemActionBase {
    constructor(
        id: string,
        actionSeason: string,
        status: string,
        note: string,
        public readonly type: string,
        purchaseDate: string,
        startDate: string,
        arriveDate: string,
        endDate: string,
        saleChangeRatio: string,
        saleIncrease: string,
        public readonly safetyStock: string,
        public readonly averageSaleOverReplTime: string,
        public readonly bufferOld: string,
        public readonly bufferNew: string,
        public readonly bufferAfterAction: string,
        replenishment: string,
        actionOut: string,
        public readonly nestedAction: string,
        importDate: string,
        documentNumber: string,
        cancelAction: string,
        purchaseType: string,
        prevActionAvgSale : string,
        prevActionPeriod : string,
        prevActionDocumentNumber : string,
        addAdditionalStock : number
        ) {
        super(id,
            actionSeason,
            status,
            note,
            purchaseDate,
            startDate,
            arriveDate,
            endDate,
            saleChangeRatio,
            saleIncrease,
            replenishment,
            actionOut,
            importDate,
            documentNumber,
            cancelAction,
            purchaseType,
            prevActionAvgSale,
            prevActionPeriod,
            prevActionDocumentNumber,
            addAdditionalStock);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/item-action.ts